"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/asyncToGenerator"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _create = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/create"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));

var _lodash = _interopRequireDefault(require("lodash"));

var _Logger = _interopRequireDefault(require("@/libs/Logger"));

var _BouncerMiddleware = _interopRequireDefault(require("@/libs/BouncerMiddleware"));

var log = _Logger.default.namespace('BouncerProvider.js');

var BouncerProvider = /*#__PURE__*/function () {
  function BouncerProvider(state) {
    var _context, _context2;

    (0, _classCallCheck2.default)(this, BouncerProvider);
    this.state = state; // This is the network that will be used to control the bouncer

    this.controllerNetwork = null; // The detected credentials for the BNC

    this.bnc = {
      enabled: false,
      username: '',
      password: '',
      server: '',
      port: 6667,
      tls: false,
      direct: false,
      path: '',
      registered: false
    }; // If enabled, new IRC connections will be re-routed through the bouncer

    this.rewriteConnections = true; // A snapshot of the current networks. Compared against to detect changed networks

    this.networksSnapshot = (0, _create.default)(null); // If we are currently monitoring for network settings changes

    this.monitoringChanges = false;
    state.$on('irc.motd', (0, _bind.default)(_context = this.onNetworkMotd).call(_context, this));
    state.$on('irc.bouncer state', (0, _bind.default)(_context2 = this.onNetworkState).call(_context2, this));
  }

  (0, _createClass2.default)(BouncerProvider, [{
    key: "enable",
    value: function enable(server, port, tls, direct, path) {
      this.bnc.server = server;
      this.bnc.port = port || 6667;
      this.bnc.tls = !!tls;
      this.bnc.direct = !!direct;
      this.bnc.path = path || '';
      this.bnc.enabled = true; // this.monitorNetworkChanges();

      this.listenToState();
    } // Try to get a connected network that can be used to control the bouncer

  }, {
    key: "getController",
    value: function getController() {
      if (this.controllerNetwork && this.controllerNetwork.state === 'connected') {
        return this.controllerNetwork;
      }

      this.controllerNetwork = null;

      for (var i = 0; i < this.state.networks.length; i++) {
        var network = this.state.networks[i];
        var client = network.ircClient;

        if (network.state === 'connected' && client.network.cap.isEnabled('bouncer')) {
          this.controllerNetwork = network;
          break;
        }
      }

      return this.controllerNetwork;
    }
  }, {
    key: "onNetworkMotd",
    value: function () {
      var _onNetworkMotd = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(event, network) {
        var client, _network$connection$p, _network$connection$p2, username, password;

        return _regenerator.default.wrap(function _callee$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                client = network.ircClient;

                if (this.bnc.enabled) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                if (client.network.cap.isEnabled('bouncer')) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                // Set the bncnetid if the network upstream exists and we havn't already set it
                if (client.bnc.hasNetwork() && !network.connection.bncnetid) {
                  network.connection.bncnetid = client.bnc.tags().netid;
                } // Use this initial network password for other network connections


                if (!this.bnc.username) {
                  _network$connection$p = network.connection.password.split(':'), _network$connection$p2 = (0, _slicedToArray2.default)(_network$connection$p, 2), username = _network$connection$p2[0], password = _network$connection$p2[1];
                  username = username.split('/')[0];
                  this.bnc.username = username;
                  this.bnc.password = password;
                } // If this is a BNC network, sync it before anything else so that we get all it's info
                // and buffer states as soon as possible


                if (!client.bnc.hasNetwork()) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 10;
                return this.syncBncNetwork(network);

              case 10:
                _context3.next = 12;
                return this.initAndAddNetworks(network);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee, this);
      }));

      function onNetworkMotd(_x, _x2) {
        return _onNetworkMotd.apply(this, arguments);
      }

      return onNetworkMotd;
    }()
  }, {
    key: "onNetworkState",
    value: function onNetworkState(event, network) {
      var isController = this.getController() === network; // We get connection state changes advertised on all bouncer connections, so only handle
      // the ones that come from the controller network since we only need to deal with it once.

      if (isController && event.state === 'disconnected') {
        // Mimick any network disconnections by closing this connection too
        var effectedNetwork = this.state.getNetworkFromBncNetId(event.networkId);

        if (effectedNetwork) {
          effectedNetwork.ircClient.connection.transport.close();
        }
      }
    }
  }, {
    key: "initAndAddNetworks",
    value: function () {
      var _initAndAddNetworks = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(network) {
        var _this = this;

        var client, bncNetworks;
        return _regenerator.default.wrap(function _callee2$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                client = network.ircClient;
                this.bnc.registered = true; // hide the empty (non-network) controller network

                if (!network.ircClient.bnc.hasNetwork()) {
                  network.hidden = true;
                } else {
                  network.hidden = false;
                } // populate network list from the controller connection


                _context4.next = 5;
                return client.bnc.getNetworks();

              case 5:
                bncNetworks = _context4.sent;
                (0, _forEach.default)(bncNetworks).call(bncNetworks, function (bncNet) {
                  return _this.addNetworkToState(bncNet);
                }); // start monitoring network changes

                this.monitorNetworkChanges();

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee2, this);
      }));

      function initAndAddNetworks(_x3) {
        return _initAndAddNetworks.apply(this, arguments);
      }

      return initAndAddNetworks;
    }()
  }, {
    key: "syncBncNetwork",
    value: function () {
      var _syncBncNetwork = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(bncNetwork) {
        var _this2 = this,
            _context5;

        var client, buffers;
        return _regenerator.default.wrap(function _callee3$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                client = bncNetwork.ircClient;
                _context6.next = 3;
                return client.bnc.getBuffers(bncNetwork.connection.bncnetid);

              case 3:
                buffers = _context6.sent;
                (0, _forEach.default)(buffers).call(buffers, function (buffer) {
                  var newBuffer = _this2.state.addBuffer(bncNetwork.id, buffer.name);

                  if (buffer.joined) {
                    newBuffer.enabled = true;
                    newBuffer.joined = true;
                  } else {
                    newBuffer.enabled = false;
                    newBuffer.joined = false;
                  }

                  if (buffer.seen) {
                    newBuffer.last_read = new Date(buffer.seen).getTime();
                  }

                  newBuffer.topic = buffer.topic || '';

                  if (bncNetwork.state === 'connected' && newBuffer.isChannel() && newBuffer.joined) {
                    client.raw('NAMES ' + newBuffer.name);
                    client.who(newBuffer.name);
                  }
                }); // Remove any existing buffers that we no longer have on the bouncer

                (0, _forEach.default)(_context5 = bncNetwork.buffers).call(_context5, function (clientBuffer) {
                  if (!clientBuffer.isChannel() && !clientBuffer.isQuery()) {
                    return;
                  }

                  var existingBuffers = (0, _filter.default)(buffers).call(buffers, function (bncBuffer) {
                    return bncBuffer.name.toLowerCase() === clientBuffer.name.toLowerCase();
                  });

                  if (existingBuffers.length === 0) {
                    _this2.state.removeBuffer(clientBuffer);
                  }
                });

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee3);
      }));

      function syncBncNetwork(_x4) {
        return _syncBncNetwork.apply(this, arguments);
      }

      return syncBncNetwork;
    }()
  }, {
    key: "addNetworkToState",
    value: function () {
      var _addNetworkToState = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(network) {
        var net;
        return _regenerator.default.wrap(function _callee4$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                // Expects network to be in the format of:
                //  {
                //  "networkId":"xyz",
                //  "name":"freenode",
                //  "channel":"1",
                //  "connected":"1",
                //  "host":"irc.freenode.net",
                //  "port":"6667",
                //  "tls":"0",
                //  "nick":"notprawn99829"
                //  },
                net = this.state.getNetworkFromBncNetId(network.networkId);

                if (!net) {
                  net = this.state.addNetwork(network.name, network.nick || '', {
                    server: network.host,
                    port: network.port,
                    tls: network.tls,
                    password: network.password || '',
                    bncnetid: network.networkId,
                    username: network.user,
                    account_password: network.account_password
                  });
                } else {// TODO: Update our existing network
                }

                _context7.next = 4;
                return this.syncBncNetwork(net);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee4, this);
      }));

      function addNetworkToState(_x5) {
        return _addNetworkToState.apply(this, arguments);
      }

      return addNetworkToState;
    }() // Keep a snapshot of what the current networks are. They will be periodically
    // compared with the active networks to see if anything has changed before
    // saving those changes.

  }, {
    key: "snapshotCurrentNetworks",
    value: function snapshotCurrentNetworks() {
      var _context8,
          _this3 = this;

      this.networksSnapshot = (0, _create.default)(null);
      (0, _forEach.default)(_context8 = this.state.networks).call(_context8, function (network) {
        if (!network.connection.bncnetid) {
          return;
        }

        _this3.networksSnapshot[network.connection.bncnetid] = {
          bncnetid: network.connection.bncnetid,
          network: network.name,
          host: network.connection.server,
          port: network.connection.port,
          tls: network.connection.tls,
          account_password: network.password,
          server_password: network.connection.password,
          nick: network.connection.nick,
          username: network.username
        };
      });
    } // Compare the current networks with our previously saved snapshot of
    // networks. Save any changes to the bouncer

  }, {
    key: "saveState",
    value: function saveState() {
      var _context9,
          _this4 = this;

      var controller = this.getController();

      if (!controller) {
        log('No controller available to save networks');
        return;
      }

      (0, _forEach.default)(_context9 = this.state.networks).call(_context9, function (network) {
        // don't save an empty controller to the network.
        // we can't use hasNetwork alone because that requires ircClient to be
        //  connected, and we save new nets before they are connected
        if (_this4.getController() === network && !network.ircClient.bnc.hasNetwork()) {
          return;
        } // Don't save any hidden networks. This includes the BNC controller network


        if (network.hidden) {
          return;
        }

        var bncnetid = network.connection.bncnetid;
        var snapshot = _this4.networksSnapshot[bncnetid] || {};
        var tags = {};

        if (network.name !== snapshot.network) {
          tags.network = network.name;
        }

        if (network.connection.server !== snapshot.host) {
          tags.host = network.connection.server;
        }

        if (network.connection.port !== snapshot.port) {
          tags.port = network.connection.port;
        }

        if (network.connection.tls !== snapshot.tls) {
          tags.tls = network.connection.tls;
        }

        if (network.password !== snapshot.account_password) {
          tags.account_password = network.password;
        }

        if (network.connection.password !== snapshot.server_password) {
          tags.password = network.connection.password;
        }

        if (network.connection.nick !== snapshot.nick) {
          tags.nick = network.connection.nick;
        }

        if (network.username !== snapshot.username) {
          tags.user = network.username;
        } // A newly added network would not have a snapshot name (bncnetid) property set yet.
        // Only save the network if we've entered connection info.


        if (!snapshot.bncnetid && tags.host && tags.port && tags.nick) {
          // ?? network.connection.bncname = network.name;
          controller.ircClient.bnc.addNetwork(network.name, tags.host, tags.port, tags.tls, tags.nick, tags.user, tags.password).then(function (networkInfo) {
            network.connection.bncnetid = networkInfo.networkId;
            network.name = networkInfo.network;
          });
        } else if (snapshot.bncnetid && (0, _keys.default)(tags).length > 0) {
          controller.ircClient.bnc.saveNetwork(bncnetid, tags);
        }
      });
      this.snapshotCurrentNetworks();
    }
  }, {
    key: "monitorNetworkChanges",
    value: function monitorNetworkChanges() {
      var _context10;

      if (this.monitoringChanges) {
        return;
      }

      this.monitoringChanges = true;
      this.snapshotCurrentNetworks();

      var debouncedSaveState = _lodash.default.debounce((0, _bind.default)(_context10 = this.saveState).call(_context10, this), 2000);

      this.state.$watch('networks', debouncedSaveState, {
        deep: true
      });
    }
  }, {
    key: "listenToState",
    value: function listenToState() {
      var _this5 = this;

      var state = this.state; // Just before we connect to a network, make sure the BNC is saved and connected to
      // it or at least trying to connect.
      // Ie. Quickly creating a network and hitting connect before it's had time to
      //     save itself to the bouncer

      state.$on('network.connecting', function (event) {
        // Redirect the connection towards the bouncer with the network specific password
        var network = event.network;

        if (_this5.bnc.enabled && _this5.rewriteConnections) {
          var netname = network.name;
          var ircClient = network.ircClient;
          ircClient.options.host = _this5.bnc.server;
          ircClient.options.port = _this5.bnc.port;
          ircClient.options.tls = _this5.bnc.tls;

          if (_this5.bnc.password) {
            var _context11, _context12;

            var password = (0, _concat.default)(_context11 = (0, _concat.default)(_context12 = "".concat(_this5.bnc.username, "/")).call(_context12, netname, ":")).call(_context11, _this5.bnc.password);
            ircClient.options.password = password;
          } // The SASL auth already happens on the BNC, we only use it for UI purposes in kiwi


          ircClient.options.account = {};
          network.connection.direct = _this5.bnc.direct;
          ircClient.options.path = _this5.bnc.path;
        }
      });
      state.$on('network.connecting', function (event) {
        var controller = _this5.getController();

        if (!controller) {
          log('No controller available to save network states');
          return;
        }

        _this5.saveState();

        var network = event.network;

        if (network.connection.bncnetid) {
          controller.ircClient.raw('BOUNCER connect ' + network.connection.bncnetid);
        }
      });
      state.$on('irc.motd', function (event, network) {
        var _context13;

        (0, _forEach.default)(_context13 = network.buffers).call(_context13, function (buffer) {
          if (buffer.isChannel() && buffer.enabled && buffer.joined) {
            network.ircClient.who(buffer.name);
          }
        });
      });
      state.$on('network.new', function (event) {
        var network = event.network; // Enable BOUNCER on this connection

        network.ircClient.use((0, _BouncerMiddleware.default)()); // Update the network name to NetworkN if hasn't got once from the bouncer yet

        if (!network.connection.bncnetid) {
          var currentNum = 1;
          var existingNet = true;

          while (existingNet) {
            existingNet = (0, _find.default)(_lodash.default).call(_lodash.default, state.networks, {
              name: 'Network' + currentNum
            });

            if (!existingNet || network === existingNet) {
              network.name = 'Network' + currentNum;
              existingNet = null;
            }

            currentNum++;
          }
        }
      });
      state.$on('network.removed', function (event) {
        var controller = _this5.getController();

        if (!controller) {
          log('No controller available to save network states');
          return;
        }

        if (event.network.connection.bncnetid) {
          controller.ircClient.bnc.removeNetwork(event.network.connection.bncnetid);
        }
      });
      state.$on('buffer.close', function (event) {
        var buffer = event.buffer;
        var network = event.buffer.getNetwork();
        var bncnetid = network.connection.bncnetid;

        var controller = _this5.getController();

        if (!controller) {
          log('No controller available to save buffer states');
          return;
        }

        if (bncnetid) {
          controller.ircClient.bnc.closeBuffer(bncnetid, buffer.name);
        }
      });
    }
  }]);
  return BouncerProvider;
}();

exports.default = BouncerProvider;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["BouncerProvider"]
window._kiwi_exports.libs.BouncerProvider = exports.default ? exports.default : exports;
